export default __webpack_public_path__ + "assets/images/topaasia-hex-logo.4d4b364de3f08ce2310b1d128fd10e4a.png";